import Vue from 'vue';
import Router from 'vue-router';

import NotFound from '../views/404/index.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',  // 使用 HTML5 history 模式
    routes: [
        {
            path: '/login',
            component: () => import('@/views/system/login/login'),
        },
        {
            path: '/',
            redirect: 'login',
        },
        {
            path: '/help-center',
            name: 'helpCenterStandalone',
            component: () => import('@/views/helpCenter/index.vue'),
            props: {
                standalone: true,
            },
        },
        {
            path: '/niuhui',
            name: 'niuhui',
            component: () => import('@/components/index'),
            children: [
                {
                    path: '',
                    components: {
                        table: () => import('@/views/system/index/index.vue'),
                    },
                },
                {
                    path: 'help-center',
                    name: 'helpCenter',
                    components: {
                        table: () => import('@/views/helpCenter/index.vue'),
                    },
                },
                {
                    path: 'user',
                    name: 'User',
                    components: {
                        table: () => import('@/views/system/user/User.vue'),
                    },
                },
                {
                    path: 'respSales',
                    name: 'respSales',
                    components: {
                        table: () => import('@/views/finance/respSales/inde'),
                    },
                },
                {
                    path: 'warehouse',
                    name: 'warehouse',
                    components: { table: () => import('@/views/operate/warehouse/index') },
                },
                {
                    path: 'unsalablePrice',
                    name: 'unsalablePrice',
                    components: { table: () => import('@/views/supply/unsalablePrice/index') },
                },
                {
                    path: 'abnormalLogistics',
                    name: 'abnormalLogistics',
                    components: { table: () => import('@/views/logistics/abnormalLogistics/index') },
                },
                {
                    path: 'requestOrder',
                    name: 'requestOrder',
                    components: { table: () => import('@/views/finance/requestOrder/index') },
                },
                {
                    path: 'requestProvider',
                    name: 'requestProvider',
                    components: { table: () => import('@/views/finance/requestProvider/index') },
                },
                {
                    path: 'dept',
                    name: 'dept',
                    components: { table: () => import('@/views/system/dept/index') },
                },
                {
                    path: 'newProduct',
                    name: 'newProduct',
                    components: { table: () => import('@/views/productM/product/newProduct') },
                },
                {
                    path: 'newProductV2',
                    name: 'newProductV2',
                    components: { table: () => import('@/views/productM/product/index.vue') },
                },
                {
                    path: 'newProductMonitoring',
                    name: 'newProductMonitoring',
                    components: { table: () => import('@/views/productM/product/newProductMonitoring.vue') },
                },
                {
                    path: 'product/category-monitoring',
                    alias: 'categoryMonitoring',
                    name: 'categoryMonitoring',
                    components: { table: () => import('@/views/productM/categoryMonitoring/MonitorList.vue') },
                    meta: { workspaceTitle: '品类监控', breadcrumb: ['品类监控'], documentTitle: '品类监控' },
                },
                {
                    path: 'product/category-monitoring/:monitorId',
                    alias: 'categoryMonitoring/:monitorId',
                    name: 'categoryMonitoringDetail',
                    components: { table: () => import('@/views/productM/categoryMonitoring/MonitorDetail.vue') },
                    props: { table: true },
                    meta: { workspaceTitle: '末级品类详情', breadcrumb: ['品类监控', '末级品类详情'], documentTitle: '末级品类详情' },
                },
                {
                    path: 'product/category-monitoring/:monitorId/taxonomy',
                    alias: 'categoryMonitoring/:monitorId/taxonomy',
                    name: 'categoryMonitoringTaxonomy',
                    components: { table: () => import('@/views/productM/categoryMonitoring/Taxonomy.vue') },
                    props: { table: true },
                    meta: { workspaceTitle: '自定义子品类', breadcrumb: ['品类监控', '末级品类详情', '自定义子品类'], documentTitle: '自定义子品类' },
                },
                {
                    path: 'ctrCvr',
                    name: 'ctrCvr',
                    components: { table: () => import('@/views/productM/product/ctrCvr') },
                },
                {
                    path: 'targetResp',
                    name: 'targetResp',
                    components: { table: () => import('@/views/operate/targetResp/index') },
                },
                {
                    path: 'mkdNewProduct',
                    name: 'mkdNewProduct',
                    components: { table: () => import('@/views/operate/mkdNewProduct/index') },
                },
                {
                    path: 'mercadoOutPut',
                    name: 'mercadoOutPut',
                    components: { table: () => import('@/views/multiplatform/mercadoOutPut/index.vue') },
                },
                {
                    path: 'pendingOutbound',
                    name: 'pendingOutbound',
                    components: { table: () => import('@/views/multiplatform/pendingOutbound/index.vue') },
                },
                {
                    path: 'threeDragonsOutErrors',
                    alias: 'three-dragons/out-errors',
                    name: 'threeDragonsOutErrors',
                    components: { table: () => import('@/views/multiplatform/threeDragonsOutError/index.vue') },
                },
                {
                    path: 'threeDragonsReturnWarehouse',
                    alias: 'three-dragons/return-warehouse',
                    name: 'threeDragonsReturnWarehouse',
                    components: { table: () => import('@/views/multiplatform/threeDragonsReturnWarehouse/index.vue') },
                },
                {
                    path: 'ctrManager',
                    name: 'ctrManager',
                    components: { table: () => import('@/views/productM/ctr/index') },
                },
                {
                    path: 'expertInfo',
                    name: 'expertInfo',
                    components: { table: () => import('@/views/tiktok/expertInfo/index') },
                },
                {
                    path: 'analysis',
                    name: 'analysis',
                    components: { table: () => import('@/views/tiktok/analysis/index') },
                },
                {
                    path: 'status',
                    name: 'status',
                    components: { table: () => import('@/views/tiktok/status/index') },
                },
                {
                    path: 'expertIntentionalInfo',
                    name: 'expertIntentionalInfo',
                    components: { table: () => import('@/views/tiktok/expertIntentionalInfo/index') },
                },
                {
                    path: 'product',
                    name: 'product',
                    components: { table: () => import('@/views/tiktok/product/index') },
                },
                {
                    path: 'cooperate',
                    name: 'cooperate',
                    components: { table: () => import('@/views/tiktok/cooperate/index') },
                },
                {
                    path: 'video',
                    name: 'video',
                    components: { table: () => import('@/views/tiktok/video/index') },
                },
                {
                    path: 'sendSample',
                    name: 'sendSample',
                    components: { table: () => import('@/views/tiktok/sendSample/index') },
                },
                {
                    path: 'logisticsCost',
                    name: 'logisticsCost',
                    components: { table: () => import('@/views/logistics/logisticsCost/index') },
                },
                {
                    path: 'logisticsFee',
                    name: 'logisticsFee',
                    components: { table: () => import('@/views/logistics/logisticsFee/index.vue') },
                },
                {
                    path: 'logisticsUnion',
                    name: 'logisticsUnion',
                    components: { table: () => import('@/views/logistics/logisticsUnion/index.vue') },
                },
                {
                    path: 'logisticsUnionDetail',
                    name: 'logisticsUnionDetail',
                    components: { table: () => import('@/views/logistics/logisticsUnion/detail.vue') },
                },
                {
                    path: 'logisticsUnionGoods',
                    name: 'logisticsUnionGoods',
                    components: { table: () => import('@/views/logistics/logisticsUnionGoods/index.vue') },
                },
                {
                    path: 'logisticsUnionBox',
                    name: 'logisticsUnionBox',
                    components: { table: () => import('@/views/logistics/logisticsUnionBox/index.vue') },
                },
                {
                    path: 'logisticsHeadFeeUnion',
                    name: 'logisticsHeadFeeUnion',
                    components: { table: () => import('@/views/logistics/logisticsHeadFeeUnion/index.vue') },
                },
                {
                    path: 'logisticsFirstLegCostDetail',
                    name: 'logisticsFirstLegCostDetail',
                    components: { table: () => import('@/views/logistics/logisticsFirstLegCostDetail/index.vue') },
                },
                {
                    path: 'deliveryNoteSource',
                    name: 'deliveryNoteSource',
                    components: { table: () => import('@/views/logistics/deliveryNoteSource/index.vue') },
                },
                {
                    path: 'deliveryNoteSourceDetail',
                    name: 'deliveryNoteSourceDetail',
                    components: { table: () => import('@/views/logistics/deliveryNoteSource/detail.vue') },
                },
                {
                    path: 'calculate',
                    name: 'calculate',
                    components: { table: () => import('@/views/logistics/logisticsCost/calculate') },
                },
                {
                    path: 'menu',
                    name: 'menu',
                    components: { table: () => import('@/views/system/menu/index') },
                },
                {
                    path: 'role',
                    name: 'role',
                    components: { table: () => import('@/views/system/role/index') },
                },
                {
                    path: 'auth',
                    name: 'auth',
                    components: { table: () => import('@/views/system/auth/index') },
                },
                {
                    path: 'logisticsTrack',
                    name: 'logisticsTrack',
                    components: { table: () => import('@/views/logistics/logisticsTrack/index') },
                },
                {
                    path: 'logisticsTrackTarget',
                    name: 'logisticsTrackTarget',
                    components: { table: () => import('@/views/logistics/logisticsTrackTarget/index') },
                },
                {
                    path: 'logisticsMonitorV2',
                    name: 'logisticsMonitorV2',
                    components: { table: () => import('@/views/logistics/logisticsMonitorV2/index.vue') },
                },
                {
                    path: 'productEntrySearch',
                    name: 'productEntrySearch',
                    components: { table: () => import('@/views/supply/productEntrySearch/index') },
                },
                {
                    path: 'baseWarehouse',
                    name: 'baseWarehouse',
                    components: { table: () => import('@/views/supply/baseWarehouse/index.vue') },
                },
                {
                    path: 'mainSubSkuMapping',
                    name: 'mainSubSkuMapping',
                    components: { table: () => import('@/views/supply/mainSubSkuMapping/index.vue') },
                },
                {
                    path: 'amzOldProductLevel',
                    name: 'amzOldProductLevel',
                    components: { table: () => import('@/views/amzOld/index') },
                },
                {
                    path: 'devLog',
                    name: 'devLog',
                    components: { table: () => import('@/views/system/devLog/index.vue') },
                },
                {
                    path: 'loginNotice',
                    name: 'loginNotice',
                    components: { table: () => import('@/views/system/releaseNotice/index.vue') },
                },
                {
                    path: 'booth',
                    name: 'booth',
                    components: { table: () => import('@/views/stats/booth/index.vue') },
                },
                {

                    path: 'shein',
                    name: 'shein',
                    components: { table: () => import('@/views/multiplatform/shein/index.vue') },
                },
                {
                    path: 'tiktok',
                    name: 'tiktok',
                    components: { table: () => import('@/views/multiplatform/tiktok/index.vue') },
                },
                {
                    path: 'sheinDataInfo',
                    name: 'sheinDataInfo',
                    components: { table: () => import('@/views/multiplatform/shein/data.vue') },
                },
                {
                    path: 'sheinData',
                    name: 'sheinData',
                    components: { table: () => import('@/views/multiplatform/shein/dataInfo.vue') },
                },
                {
                    path: 'tiktokDataInfo',
                    name: 'tiktokDataInfo',
                    components: { table: () => import('@/views/multiplatform/tiktok/dataInfo.vue') },
                },
                {
                    path: 'tiktokData',
                    name: 'tiktokData',
                    components: { table: () => import('@/views/multiplatform/tiktok/data.vue') },
                },
                {
                    path: 'log',
                    name: 'log',
                    components: { table: () => import('@/views/system/log/data.vue') },
                },
                {
                    path: 'globalOperationLog',
                    name: 'globalOperationLog',
                    components: { table: () => import('@/views/system/globalOperationLog/index.vue') },
                },
                {
                    path: 'color',
                    name: 'color',
                    components: { table: () => import('@/views/system/color/index.vue') },
                },
                {
                    path: 'platformSum',
                    name: 'platformSum',
                    components: { table: () => import('@/views/multiplatform/sum/index.vue') },
                },
                {
                    path: 'temu',
                    name: 'temu',
                    components: { table: () => import('@/views/multiplatform/temu/index.vue') },
                },
                {
                    path: 'temuData',
                    name: 'temuData',
                    components: { table: () => import('@/views/multiplatform/temu/data.vue') },
                },
                {
                    path: 'temuAccount',
                    name: 'temuAccount',
                    components: { table: () => import('@/views/multiplatform/temu/account.vue') },
                },
                {
                    path: 'temuShop',
                    name: 'temuShop',
                    components: { table: () => import('@/views/multiplatform/temu/shop.vue') },
                },
                {
                    path: 'temuDataInfo',
                    name: 'temuDataInfo',
                    components: { table: () => import('@/views/multiplatform/temu/dataInfo.vue') },
                },
                {
                    path: 'temuAlltrusteeship',
                    name: 'temuAlltrusteeship',
                    components: { table: () => import('@/views/multiplatform/temu/temuAlltrusteeship.vue') },
                },
                {
                    path: 'tkExcelBatches',
                    alias: 'tk-excel/batches',
                    name: 'tkExcelBatches',
                    components: { table: () => import('@/views/tiktok/tkExcelResult/batches.vue') },
                },
                {
                    path: 'tkExcelBatchDetails/:batchId',
                    alias: 'tk-excel/batches/:batchId/details',
                    name: 'tkExcelBatchDetails',
                    components: { table: () => import('@/views/tiktok/tkExcelResult/details.vue') },
                },
                {
                    path: 'tkExcelLatest',
                    alias: 'tk-excel/latest',
                    name: 'tkExcelLatest',
                    components: { table: () => import('@/views/tiktok/tkExcelResult/latest.vue') },
                },
                {
                    path: 'lazadaExcelGenerate',
                    alias: ['lazada-excel/generate', 'lazada-report/batches'],
                    name: 'lazadaExcelGenerate',
                    components: { table: () => import('@/views/lazada/lazadaReport/index.vue') },
                },
                {
                    path: 'lazadaReportBatchDetails/:batchId',
                    alias: 'lazada-report/batches/:batchId/results',
                    name: 'lazadaReportBatchDetails',
                    components: { table: () => import('@/views/lazada/lazadaReport/details.vue') },
                },
                {
                    path: 'tkIndonesiaShopOperatorMappings',
                    alias: 'tk-excel/indonesia-shop-operator-mappings',
                    name: 'tkIndonesiaShopOperatorMappings',
                    components: { table: () => import('@/views/tiktok/indonesiaMappings/shopOperator.vue') },
                },
                {
                    path: 'tkIndonesiaSkuMappings',
                    alias: 'tk-excel/indonesia-sku-mappings',
                    name: 'tkIndonesiaSkuMappings',
                    components: { table: () => import('@/views/tiktok/indonesiaMappings/skuMapping.vue') },
                },
                {
                    path: 'tkComboSkuMappings',
                    alias: 'tk-excel/combo-sku-mappings',
                    name: 'tkComboSkuMappings',
                    components: { table: () => import('@/views/tiktok/indonesiaMappings/comboSku.vue') },
                },
                {
                    path: 'shopeeReportBatches',
                    alias: 'shopee-report/batches',
                    name: 'shopeeReportBatches',
                    components: { table: () => import('@/views/shopee/reportResult/batches.vue') },
                },
                {
                    path: 'shopeeReportResults/:batchId',
                    alias: 'shopee-report/batches/:batchId/results',
                    name: 'shopeeReportResults',
                    components: { table: () => import('@/views/shopee/reportResult/results.vue') },
                },
                {
                    path: 'shopeeReportLatest',
                    alias: 'shopee-report/latest',
                    name: 'shopeeReportLatest',
                    components: { table: () => import('@/views/shopee/reportResult/latest.vue') },
                },
                {
                    path: 'xxlJob',
                    name: 'xxlJob',
                    components: { table: () => import('@/views/system/xxlJob/index.vue') },
                },
                {
                    path: 'monitoringTask',
                    name: 'monitoringTask',
                    components: { table: () => import('@/views/system/monitoring/task.vue') },
                },
                {
                    path: 'platformOrder',
                    name: 'platformOrder',
                    components: { table: () => import('@/views/multiplatform/order/index.vue') },
                },
                {
                    path: 'productManagement',
                    name: 'productManagement',
                    components: { table: () => import('@/views/multiplatform/product/productManagement.vue') },
                },
                {
                    path: 'sendEcharts',
                    name: 'sendEcharts',
                    components: { table: () => import('@/views/multiplatform/order/echarts.vue') },
                },
                {
                    path: 'multiChannelFreight',
                    name: 'multiChannelFreight',
                    components: { table: () => import('@/views/multiChannelFreight/index.vue') },
                },
                {
                    path: 'chukou1SkuData',
                    name: 'chukou1SkuData',
                    components: { table: () => import('@/views/multiplatform/order/chukou1SkuData.vue') },
                },
                {
                    path: 'purchaseDiscount',
                    alias: 'purchase-discount',
                    name: 'purchaseDiscount',
                    components: { table: () => import('@/views/multiplatform/purchaseDiscount/index.vue') },
                },
                {
                    path: 'walmartProfit',
                    alias: 'walmart-profit',
                    name: 'walmartProfit',
                    components: { table: () => import('@/views/multiplatform/walmartProfit/index.vue') },
                },
                {
                    path: 'mercadoDailyReport',
                    alias: 'mercado-daily-report',
                    name: 'mercadoDailyReport',
                    components: { table: () => import('@/views/multiplatform/mercadoDailyReport/index.vue') },
                },
                {
                    path: 'logisticsDeadline',
                    name: 'logisticsDeadline',
                    components: { table: () => import('@/views/logistics/logisticsDeadline/index.vue') }
                },
                {
                    path: 'translationEvaluation',
                    name: 'translationEvaluation',
                    components: { table: () => import('@/views/supply/translationEvaluation/index.vue') }
                },
                {
                    path: 'provinceRegion',
                    name: 'provinceRegion',
                    components: { table: () => import('@/views/multiplatform/product/provinceRegion.vue') }
                },
                {
                    path: 'sendParam',
                    name: 'sendParam',
                    components: { table: () => import('@/views/multiplatform/product/sendParam.vue') }
                },
                {
                    path: 'logisticsDeadline',
                    name: 'logisticsDeadline',
                    components: { table: () => import('@/views/logistics/logisticsDeadline/index.vue') }
                },
                {
                    path: 'server',
                    name: 'server',
                    components: { table: () => import('@/views/system/monitoring/server.vue') }
                },
                {
                    path: 'swagger',
                    name: 'swagger',
                    components: { table: () => import('@/views/system/swagger/index.vue') }
                },
                {
                    path: "outsourcingOrders",
                    name: "outsourcingOrders",
                    components: { table: () => import('@/views/supply/outsourcingOrders/index.vue') }
                },
                {
                    path: "skuMapping",
                    name: "skuMapping",
                    components: { table: () => import('@/views/multiplatform/temu/skuMapping.vue') }
                },
                {
                    path: "repeatOrder",
                    name: "repeatOrder",
                    components: { table: () => import('@/views/supply/repeatOrder/index.vue') }
                },
                {
                    path: "repeatOrderInfo",
                    name: "repeatOrderInfo",
                    components: { table: () => import('@/views/supply/repeatOrder/repeatOrderInfo.vue') }
                },
                {
                    path: "repeatOrderInfoTarget",
                    name: "repeatOrderInfoTarget",
                    components: { table: () => import('@/views/supply/repeatOrder/target.vue') }
                },
                {
                    path: "adjustmentWarehouse",
                    name: "adjustmentWarehouse",
                    components: { table: () => import('@/views/supply/repeatOrder/adjustmentWarehouse.vue') }
                },
                {
                    path: "adjustListSource",
                    name: "adjustListSource",
                    components: { table: () => import('@/views/supply/adjustOrderSource/index.vue') }
                },
                {
                    path: "transferListSource",
                    name: "transferListSource",
                    components: { table: () => import('@/views/supply/transferOrderSource/index.vue') }
                },
                {
                    path: "inputWarehouseListSource",
                    name: "inputWarehouseListSource",
                    components: { table: () => import('@/views/supply/inputWarehouseListSource/index.vue') }
                },
                {
                    path: "inputWarehouseListSourceDetail",
                    name: "inputWarehouseListSourceDetail",
                    components: { table: () => import('@/views/supply/inputWarehouseListSource/detail.vue') }
                },
                {
                    path: "outWarehouseListSource",
                    name: "outWarehouseListSource",
                    components: { table: () => import('@/views/supply/outWarehouseListSource/index.vue') }
                },
                {
                    path: "outWarehouseListSourceDetail",
                    name: "outWarehouseListSourceDetail",
                    components: { table: () => import('@/views/supply/outWarehouseListSource/detail.vue') }
                },
                {
                    path: "workListSource",
                    name: "workListSource",
                    components: { table: () => import('@/views/supply/workOrderSource/index.vue') }
                },
                {
                    path: "workListSourceDetail",
                    name: "workListSourceDetail",
                    components: { table: () => import('@/views/supply/workOrderSource/detail.vue') }
                },
                {
                    path: "repeatOrderEcharts",
                    name: "repeatOrderEcharts",
                    components: { table: () => import('@/views/supply/repeatOrder/echarts.vue') }
                },
                {
                    path: "purchaseOrderSource",
                    name: "purchaseOrderSource",
                    components: { table: () => import('@/views/supply/purchaseOrderSource/index.vue') }
                },
                {
                    path: "purchaseOrderSourceDetail",
                    name: "purchaseOrderSourceDetail",
                    components: { table: () => import('@/views/supply/purchaseOrderSource/detail.vue') }
                },
                {
                    path: "qcListSource",
                    name: "qcListSource",
                    components: { table: () => import('@/views/supply/qcListScource/index.vue') }
                },
                {
                    path: "qcListSourceDetail",
                    name: "qcListSourceDetail",
                    components: { table: () => import('@/views/supply/qcListScource/detail.vue') }
                },
                {
                    path: "sheinStore",
                    name: "sheinStore",
                    components: {
                        table: () => import('@/views/multiplatform/shein/store.vue')
                    }
                },
                {
                    path: "unitPrice",
                    name: "unitPrice",
                    components: { table: () => import('@/views/multiplatform/shein/unitPrice.vue') }
                },
                {
                    path: "deliveryDemand",
                    name: "deliveryDemand",
                    components: { table: () => import('@/views/supply/deliveryDemand/index.vue') }
                },
                {
                    path: "repeatOrderRules",
                    name: "repeatOrderRules",
                    components: { table: () => import('@/views/supply/repeatOrder/rules.vue') }
                },
                {
                    path: "repeatOrderInventory",
                    name: "repeatOrderInventory",
                    components: { table: () => import('@/views/supply/repeatOrder/inventory.vue') }
                },
                {
                    path: "repeatOrderV2",
                    name: "repeatOrderV2",
                    components: { table: () => import('@/views/supply/repeatOrder/v2.vue') }
                },
                {
                    path: "slowMoving",
                    name: "slowMoving",
                    components: { table: () => import('@/views/supply/slowMoving/index.vue') }
                },
                {
                    path: "repeatOrderV2AllocationDashboard",
                    name: "repeatOrderV2AllocationDashboard",
                    components: { table: () => import('@/views/supply/repeatOrder/allocationDashboard.vue') }
                },
                {
                    path: "amazonKeywordAnalytics",
                    name: "amazonKeywordAnalytics",
                    components: { table: () => import('@/views/amazon/keywordAnalytics/index.vue') }
                },
                {
                    path: "amazonKeywordAnalytics/import",
                    name: "amazonKeywordAnalyticsImport",
                    components: { table: () => import('@/views/amazon/keywordAnalytics/import.vue') }
                },
                {
                    path: "amazonKeywordAnalytics/opportunities",
                    name: "amazonKeywordOpportunity",
                    components: { table: () => import('@/views/amazon/keywordAnalytics/opportunity.vue') }
                },
                {
                    path: "amazonKeywordAnalytics/explorer",
                    name: "amazonKeywordExplorer",
                    components: { table: () => import('@/views/amazon/keywordAnalytics/explorer.vue') }
                },
                {
                    path: "amazonKeywordAnalytics/lab",
                    name: "amazonMarketLab",
                    components: { table: () => import('@/views/amazon/keywordAnalytics/lab.vue') }
                },
                {
                    path: "amazonKeywordAnalytics/asins",
                    name: "amazonAsinIntelligence",
                    components: { table: () => import('@/views/amazon/keywordAnalytics/asins.vue') }
                },
                {
                    path: "threeSmallDragonSite",
                    name: "threeSmallDragonSite",
                    components: { table: () => import('@/views/supply/repeatOrder/threeSmallDragonSite.vue') }
                },
                {
                    path: "southeastAsiaPrincipal",
                    name: "southeastAsiaPrincipal",
                    components: { table: () => import('@/views/supply/repeatOrder/southeastAsiaPrincipal.vue') }
                },
                {
                    path: "salesForecast",
                    name: "salesForecast",
                    components: { table: () => import('@/views/supply/salesForecast/index.vue') }
                },
                {
                    path: "repeatDataCompare",
                    name: "repeatDataCompare",
                    components: { table: () => import('@/views/supply/repeatDataCompare/index.vue') }
                },
                {
                    path: "blueSku",
                    name: "blueSku",
                    components: { table: () => import('@/views/supply/blueSku/index.vue') }
                },

                {
                    path: "advicementsb",
                    name: "advicementsb",
                    components: { table: () => import('@/views/supply/productInfoadvertisement/productPerformanceAds.vue') }
                },
                {
                    path: "advicementsp",
                    name: "advicementsp",
                    components: { table: () => import('@/views/supply/productInfoadvertisement/productHeadlineAds.vue') }
                },


                {
                    path: "sendLogisticsOrder",
                    name: "sendLogisticsOrder",
                    components: { table: () => import('@/views/supply/sendLogisticsOrder.vue') }
                },
                {
                    path: "sendOrder",
                    name: "sendOrder",
                    components: { table: () => import('@/views/supply/sendOrder/index.vue') }
                },
                 {
                    path: "interview",
                    name: "interview",
                    components: {table: () => import('@/views/supply/interview/index.vue')}
                },
                {
                    path: "settlemnet",
                    name: "settlemnet",
                    components: {table: () => import('@/views/supply/import-templates/settlement-report.vue')}
                },

                {
                    path: "expenseway",
                    name: "expenseway",
                    components: {table: () => import('@/views/supply/import-templates/expense-way.vue')}
                },
                {
                    path: "storepeople",
                    name: "storepeople",
                    components: {table: () => import('@/views/supply/import-templates/store-people.vue')}
                },
                {
                    path: "otherprice",
                    name: "otherprice",
                    components: {table: () => import('@/views/supply/import-templates/teum-other-price.vue')}
                },


                {
                    path: "violation",
                    name: "violation",
                    components: {table: () => import('@/views/supply/import-templates/violation-template1.vue')}
                },
                {
                    path: "violationone",
                    name: "violationone",
                    components: {table: () => import('@/views/supply/import-templates/violation-template2.vue')}
                },
                {
                    path: "disposal",
                    name: "disposal",
                    components: {table: () => import('@/views/supply/import-templates/disposal-fee.vue')}
                },
                {
                    path: "sellrejection",
                    name: "sellrejection",
                    components: {table: () => import('@/views/supply/import-templates/seller-rejection.vue')}
                },
                {
                    path: "financial",
                    name: "financial",
                    components: {table: () => import('@/views/supply/import-templates/financial-details.vue')}
                }, {
                    path: "orderTeum",
                    name: "orderTeum",
                    components: {table: () => import('@/views/supply/import-templates/orderTeumDetail.vue')}
                },
                {
                    path: "skumappingbylx",
                    name: "skumappingbylx",
                    components: { table: () => import('@/views/supply/LingXingByMKD/sku-batch-mapping.vue') }
                },
                {
                    path: "productList",
                    name: "productList",
                    components: { table: () => import('@/views/productM/index.vue') }
                },
                {
                    path: "selectionCandidates",
                    name: "selectionCandidates",
                    components: { table: () => import('@/views/productM/selectionCandidates/index.vue') }
                },
                {
                    path: "listingRecords",
                    redirect: "/niuhui/listingTagRecord"
                },
                {
                    path: "listingTagRecord",
                    name: "listingTagRecord",
                    components: { table: () => import('@/views/listing/records/tagRecord.vue') }
                },
                {
                    path: "listingOldProductLevelRecord",
                    name: "listingOldProductLevelRecord",
                    components: { table: () => import('@/views/listing/records/oldProductLevelRecord.vue') }
                },
                {
                    path: "listingNewProductTagPushRecord",
                    name: "listingNewProductTagPushRecord",
                    components: { table: () => import('@/views/listing/records/newProductTagPushRecord.vue') }
                },
                {
                    path: "listingDeletedTagCleanRecord",
                    name: "listingDeletedTagCleanRecord",
                    components: { table: () => import('@/views/listing/records/deletedTagCleanRecord.vue') }
                },
                {
                    path: "listingNewProductPushData",
                    name: "listingNewProductPushData",
                    components: { table: () => import('@/views/listing/records/newProductPushData.vue') }
                },
                {
                    path: "listingNewProductGradeRecord",
                    name: "listingNewProductGradeRecord",
                    components: { table: () => import('@/views/listing/records/newProductGradeRecord.vue') }
                },
                {
                    path: "listingNewProductDefinitionCandidate",
                    name: "listingNewProductDefinitionCandidate",
                    components: { table: () => import('@/views/listing/records/newProductDefinitionCandidate.vue') }
                },
                {
                    path: "threeDragonsListing",
                    name: "threeDragonsListing",
                    components: { table: () => import('@/views/listing/threeDragons/listing.vue') }
                },
                {
                    path: "threeDragonsListingGradeRecord",
                    name: "threeDragonsListingGradeRecord",
                    components: { table: () => import('@/views/listing/threeDragons/gradeRecord.vue') }
                },
                {
                    path: "threeDragonsListingDefinitionCandidate",
                    name: "threeDragonsListingDefinitionCandidate",
                    components: { table: () => import('@/views/listing/threeDragons/definitionCandidate.vue') }
                },
                {
                    path: "threeDragonsListingGradeTask",
                    name: "threeDragonsListingGradeTask",
                    components: { table: () => import('@/views/listing/threeDragons/gradeTask.vue') }
                },
                {
                    path: "threeDragonsListingOldProductGradeRecord",
                    name: "threeDragonsListingOldProductGradeRecord",
                    components: { table: () => import('@/views/listing/threeDragons/oldProductGradeRecord.vue') }
                },
                {
                    path: "southeastAsiaListing",
                    name: "southeastAsiaListing",
                    components: { table: () => import('@/views/listing/southeastAsia/listing.vue') }
                },
                {
                    path: "southeastAsiaListingGradeRecord",
                    name: "southeastAsiaListingGradeRecord",
                    components: { table: () => import('@/views/listing/southeastAsia/gradeRecord.vue') }
                },
                {
                    path: "southeastAsiaListingDefinitionCandidate",
                    name: "southeastAsiaListingDefinitionCandidate",
                    components: { table: () => import('@/views/listing/southeastAsia/definitionCandidate.vue') }
                },
                {
                    path: "southeastAsiaListingGradeTask",
                    name: "southeastAsiaListingGradeTask",
                    components: { table: () => import('@/views/listing/southeastAsia/gradeTask.vue') }
                },
                {
                    path: "southeastAsiaListingOldProductGradeRecord",
                    name: "southeastAsiaListingOldProductGradeRecord",
                    components: { table: () => import('@/views/listing/southeastAsia/oldProductGradeRecord.vue') }
                },
                {
                    path: "mercadoListing",
                    name: "mercadoListing",
                    components: { table: () => import('@/views/listing/mercado/listing.vue') }
                },
                {
                    path: "mercadoListingGradeRecord",
                    name: "mercadoListingGradeRecord",
                    components: { table: () => import('@/views/listing/mercado/gradeRecord.vue') }
                },
                {
                    path: "mercadoListingDefinitionCandidate",
                    name: "mercadoListingDefinitionCandidate",
                    components: { table: () => import('@/views/listing/mercado/definitionCandidate.vue') }
                },
                {
                    path: "mercadoListingGradeTask",
                    name: "mercadoListingGradeTask",
                    components: { table: () => import('@/views/listing/mercado/gradeTask.vue') }
                },
                {
                    path: "mercadoListingOldProductGradeRecord",
                    name: "mercadoListingOldProductGradeRecord",
                    components: { table: () => import('@/views/listing/mercado/oldProductGradeRecord.vue') }
                },
                {
                    path: "analysisreport",
                    name: "analysisreport",
                    components: { table: () => import('@/views/supply/repeatDataCompare/analysisReport.vue') }
                },
                {
                    path: "translationCount",
                    name: "translationCount",
                    components: { table: () => import('@/views/supply/translationEvaluation/count.vue') }
                },
                {
                    path: "yiheBatch",
                    name: "yiheBatch",
                    components: { table: () => import('@/views/logistics/yiheBatch/index.vue') }
                },
                {
                    path: "profitStatement",
                    name: "profitStatement",
                    components: { table: () => import('@/views/finance/profitStatement/index.vue') }
                },
                {
                    path: "performance",
                    name: "performance",
                    components: { table: () => import('@/views/finance/profitStatement/performance.vue') }
                },
                {
                    path: "halfDay",
                    name: "halfDay",
                    components: { table: () => import('@/views/finance/profitStatement/temu/half/day.vue') }
                },
                {
                    path: "halfMonth",
                    name: "halfMonth",
                    components: { table: () => import('@/views/finance/profitStatement/temu/half/month.vue') }
                },
                {
                    path: "completeDay",
                    name: "completeDay",
                    components: { table: () => import('@/views/finance/profitStatement/temu/complete/day.vue') }
                },
                {
                    path: "completeMonth",
                    name: "completeMonth",
                    components: { table: () => import('@/views/finance/profitStatement/temu/complete/month.vue') }
                },
                {
                    path: "sheinCompleteDay",
                    name: "sheinCompleteDay",
                    components: { table: () => import('@/views/finance/profitStatement/shein/completeDay.vue') }
                },
                {
                    path: "sheinHaltDay",
                    name: "sheinHaltDay",
                    components: { table: () => import('@/views/finance/profitStatement/shein/haltDay.vue') }
                },
                {
                    path: "sheinThirdDay",
                    name: "sheinThirdDay",
                    components: { table: () => import('@/views/finance/profitStatement/shein/thirdPartyDay.vue') }
                },
                {
                    path: "sheinCompleteMonth",
                    name: "sheinCompleteMonth",
                    components: { table: () => import('@/views/finance/profitStatement/shein/completeMonth.vue') }
                },
                {
                    path: "sheinHaltMonth",
                    name: "sheinHaltMonth",
                    components: { table: () => import('@/views/finance/profitStatement/shein/haltMonth.vue') }
                },
                {
                    path: "sheinThirdMonth",
                    name: "sheinThirdMonth",
                    components: { table: () => import('@/views/finance/profitStatement/shein/thirdPartyMonth.vue') }
                },
                {
                    path: "tkCompleteDay",
                    name: "tkCompleteDay",
                    components: { table: () => import('@/views/finance/profitStatement/tiktok/completeDay.vue') }
                },
                {
                    path: "tkThirdDay",
                    name: "tkThirdDay",
                    components: { table: () => import('@/views/finance/profitStatement/tiktok/thirdPartyDay.vue') }
                },
                {
                    path: "mercadoProfit",
                    name: "mercadoProfit",
                    components: { table: () => import('@/views/finance/profitStatement/mercado/profit.vue') }
                },
                {
                    path: "coupangDayProfit",
                    name: "coupangDayProfit",
                    components: { table: () => import('@/views/finance/profitStatement/coupang/index.vue') }
                },
                {
                    path: "shopeeDayProfit",
                    name: "shopeeDayProfit",
                    components: { table: () => import('@/views/finance/profitStatement/shopee/profit.vue') }
                },
                {
                    path: "sheinSkuError",
                    name: "sheinSkuError",
                    components: { table: () => import('@/views/finance/profitStatement/shein/skuError.vue') }
                },
                {
                    path: "mercadoRelationship",
                    name: "mercadoRelationship",
                    components: { table: () => import('@/views/finance/profitStatement/mercado/relationship.vue') }
                },
                {
                    path: "sheinSfs",
                    name: "sheinSfs",
                    components: { table: () => import('@/views/finance/profitStatement/shein/sfs.vue') }
                },
                {
                    path: "skuErrorThreeAndComplete",
                    name: "skuErrorThreeAndComplete",
                    components: { table: () => import('@/views/finance/profitStatement/shein/skuErrorThreeAndComplete.vue') }
                },
                {
                    path: "skuErrorHalfTemu",
                    name: "skuErrorHalfTemu",
                    components: { table: () => import('@/views/finance/profitStatement/temu/half/skuErrorHalf.vue') }
                },
                {
                    path: "tkAndShopeeRelationship",
                    name: "tkAndShopeeRelationship",
                    components: { table: () => import('@/views/finance/profitStatement/tiktok/relationship.vue') }
                }, {
                    path: "tkAndShopeeData",
                    name: "tkAndShopeeData",
                    components: { table: () => import('@/views/finance/profitStatement/tiktok/inData.vue') }
                },
                {
                    path: "skuCost",
                    name: "skuCost",
                    components: { table: () => import('@/views/finance/profitStatement/cost.vue') }
                },
                {
                    path: "yCInvoice",
                    name: "yCInvoice",
                    components: { table: () => import('@/views/logistics/yc/index.vue') }
                },
                {
                    path: "qcProduct",
                    name: "qcProduct",
                    components: { table: () => import('@/views/qcProduct.vue') }
                },
                {
                    path: "tkCompleteMonth",
                    name: "tkCompleteMonth",
                    components: { table: () => import('@/views/finance/profitStatement/tiktok/completeMonth.vue') }
                },
                {
                    path: "tkThreeMonth",
                    name: "tkThreeMonth",
                    components: { table: () => import('@/views/finance/profitStatement/tiktok/thirdPartyMonth.vue') }
                },
                {
                    path: "financeAllreport",
                    name: "financeAllreport",
                    components: { table: () => import('@/views/finance/report/all.vue') }
                },
                {
                    path: "indonesiaMonth",
                    name: "indonesiaMonth",
                    components: { table: () => import('@/views/finance/profitStatement/tiktok/thirdPartyMonthIndonesia.vue') }
                },
                {
                    path: "indonesiaMonthShopee",
                    name: "indonesiaMonthShopee",
                    components: { table: () => import('@/views/finance/profitStatement/shopee/profitMonth.vue') }
                },
                {
                    path: "mercadoMonthProfit",
                    name: "mercadoMonthProfit",
                    components: { table: () => import('@/views/finance/profitStatement/mercado/month.vue') }
                },
                {
                    path: "personage",
                    name: "personage",
                    components: { table: () => import('@/views/performance/personage/index') }
                },
                {
                    path: "deptPerformance",
                    name: "deptPerformance",
                    components: { table: () => import('@/views/performance/dept/index') }
                },
                {
                    path: "frontTarget",
                    name: "frontTarget",
                    components: { table: () => import('@/views/performance/frontTarget/index') }
                },
                {
                    path: "pdfMerge",
                    name: "pdfMerge",
                    components: { table: () => import('@/views/pdf/index') }
                },
                {
                    path: "purchaseTagBind",
                    name: "purchaseTagBind",
                    components: { table: () => import('@/views/pdf/purchaseTagBind') }
                }, {
                    path: "saleOrder",
                    name: "saleOrder",
                    components: { table: () => import('@/views/performance/dataSource/supply/AfterSaleOrderTab.vue') }
                }, {
                    path: "purchase",
                    name: "purchase",
                    components: { table: () => import('@/views/performance/dataSource/supply/PurchaseOrderTab.vue') }
                }, {
                    path: "productDataSource",
                    name: "productDataSource",
                    components: { table: () => import('@/views/performance/dataSource/product/index') }
                }, {
                    path: "logistics",
                    name: "logistics",
                    components: { table: () => import('@/views/performance/dataSource/logistics/index') }
                }, {
                    path: "supplySale",
                    name: "supplySale",
                    components: { table: () => import('@/views/performance/dataSource/supply/NhSale.vue') }
                }, {
                    path: "batch",
                    name: "batch",
                    components: { table: () => import('@/views/performance/dataSource/supply/NhBatch.vue') }
                }, {
                    path: "plan",
                    name: "plan",
                    components: { table: () => import('@/views/performance/dataSource/supply/NhSupplyPlan.vue') }
                }, {
                    path: "testOrder",
                    name: "testOrder",
                    components: { table: () => import('@/views/performance/dataSource/supply/NhTestOrder.vue') }
                }, {
                    path: "media",
                    name: "media",
                    components: { table: () => import('@/views/performance/dataSource/media/NhMedia.vue') }
                }, {
                    path: "NhMainSku",
                    name: "NhMainSku",
                    components: { table: () => import('@/views/import/importexcel/importVueExcel.vue') }
                }, {
                    path: "newProductTarget",
                    name: "newProductTarget",
                    components: { table: () => import('@/views/productM/product/newProductTarget.vue') }
                },
                {
                    path: "storeInfo",
                    name: "storeInfo",
                    components: { table: () => import('@/views/finance/pingpong/storeInfo.vue') }
                },
                {
                    path: "accountBalance",
                    name: "accountBalance",
                    components: { table: () => import('@/views/finance/pingpong/accountBalance.vue') }
                },
                {
                    path: "accountTransactionFlow",
                    name: "accountTransactionFlow",
                    components: { table: () => import('@/views/finance/pingpong/accountTransactionFlow.vue') }
                },
                {
                    path: "withdrawalRecord",
                    name: "withdrawalRecord",
                    components: { table: () => import('@/views/finance/pingpong/withdrawalRecord.vue') }
                },
                {
                    path: "paymentRecords",
                    name: "paymentRecords",
                    components: { table: () => import('@/views/finance/pingpong/paymentRecords.vue') }
                },
                {
                    path: "fundCollectionRecord",
                    name: "fundCollectionRecord",
                    components: { table: () => import('@/views/finance/pingpong/fundCollectionRecord.vue') }
                },
                {
                    path: "overseasWarehouse",
                    name: "overseasWarehouse",
                    components: { table: () => import('@/views/logistics/overseasWarehouse/index.vue') }
                },
                {
                    path: "SoutheastAsiaReportForms",
                    name: "SoutheastAsiaReportForms",
                    components: { table: () => import('@/views/finance/profitStatement/tiktok/SoutheastAsiaReportForms') }
                },
                {
                    path: "saProfitMargin",
                    name: "saProfitMargin",
                    components: { table: () => import('@/views/finance/profitStatement/tiktok/saProfitMargin.vue') }
                },
                {
                    path: "saProfitTarget",
                    name: "saProfitTarget",
                    components: { table: () => import('@/views/finance/profitStatement/tiktok/saProfitTarget.vue') }
                },
                {
                    path: "platformOrderOut",
                    name: "platformOrderOut",
                    components: { table: () => import('@/views/multiplatform/order/outWarehouse.vue') }
                },
                {
                    path: "seaWater",
                    name: "seaWater",
                    components: { table: () => import('@/views/multiplatform/order/seaWater.vue') }
                },
                {
                    path: "turnoverRate",
                    name: "turnoverRate",
                    components: { table: () => import('@/views/performance/dataSource/supply/TurnoverRatePage.vue') }
                },
                {
                    path: "oldMonitorTarget",
                    name: "oldMonitorTarget",
                    components: { table: () => import('@/views/amzOld/monitorTarget.vue') }
                },
                {
                    path: "oldMonitor",
                    name: "oldMonitor",
                    components: { table: () => import('@/views/amzOld/monitor.vue') }
                },
                {
                    path: "amznMonthReport",
                    name: "amznMonthReport",
                    components: { table: () => import('@/views/monthReprt/amzn/amzn.vue') }
                }, {
                    path: "allPlatformMonthReport",
                    name: "allPlatformMonthReport",
                    components: { table: () => import('@/views/monthReprt/allPlatform/allPlatformMonthReport.vue') }
                }, {
                    path: "amznStatistics",
                    name: "amznStatistics",
                    components: { table: () => import('@/views/monthReprt/amzn/amznStatistics.vue') }
                },
                {
                    path: "allPlatformShop",
                    name: "allPlatformShop",
                    components: { table: () => import('@/views/monthReprt/base/allPlatformShop.vue') }
                },
                {
                    path: "allPlatformBindSku",
                    name: "allPlatformBindSku",
                    components: { table: () => import('@/views/monthReprt/base/allPlatformBindSku.vue') }
                },
                {
                    path: "overseasWarehouseFeeConfig",
                    alias: "month-report/overseas-warehouse-fees",
                    name: "overseasWarehouseFeeConfig",
                    components: { table: () => import('@/views/monthReprt/base/overseasWarehouseFeeConfig.vue') }
                },
                {
                    path: "monthReportOperationLog",
                    alias: "month-report/operation-log",
                    name: "monthReportOperationLog",
                    components: { table: () => import('@/views/monthReprt/operationLog/dashboard.vue') }
                },
                {
                    path: "primage",
                    name: "primage",
                    components: { table: () => import('@/views/monthReprt/sheinSemi/primage.vue') }
                },
                {
                    path: "sfsOrder",
                    name: "sfsOrder",
                    components: { table: () => import('@/views/monthReprt/sheinSemi/sfsOrder.vue') }
                },
                {
                    path: "onlinePlaceOrder",
                    name: "onlinePlaceOrder",
                    components: { table: () => import('@/views/monthReprt/sheinSemi/onlinePlaceOrder.vue') }
                },
                {
                    path: "sheinSemi",
                    name: "sheinSemi",
                    components: { table: () => import('@/views/monthReprt/sheinSemi/sheinSemi.vue') }
                },
                {
                    path: "temuSemiV2",
                    name: "temuSemiV2",
                    components: { table: () => import('@/views/monthReprt/temuSemiV2/temuSemiV2.vue') }
                },
                {
                    path: "temuFull",
                    name: "temuFull",
                    components: { table: () => import('@/views/monthReprt/temuFull/temuFull.vue') }
                },
                {
                    path: "temuFullOverdueSkuMapping",
                    name: "temuFullOverdueSkuMapping",
                    components: { table: () => import('@/views/monthReprt/temuFull/temuFullOverdueSkuMapping.vue') }
                },
                {
                    path: "temuFullOverdueSku",
                    name: "temuFullOverdueSku",
                    components: { table: () => import('@/views/monthReprt/temuFull/temuFullOverdueSku.vue') }
                },
                {
                    path: "mercadoCbtMonthReport",
                    name: "mercadoCbtMonthReport",
                    components: { table: () => import('@/views/monthReprt/mercadoCbt/mercadoCbtMonthReport.vue') }
                },
                {
                    path: "mercadoStatusMapping",
                    name: "mercadoStatusMapping",
                    components: { table: () => import('@/views/monthReprt/mercadoCbt/mercadoStatusMapping.vue') }
                },
                {
                    path: "waybillFee",
                    name: "waybillFee",
                    components: { table: () => import('@/views/monthReprt/temuSemiV2/temuWaybill.vue') }
                },
                {
                    path: "sheinFull",
                    name: "sheinFull",
                    components: { table: () => import('@/views/monthReprt/sheinFull/sheinFull.vue') }
                },
                {
                    path: "tiktokFull",
                    name: "tiktokFull",
                    components: { table: () => import('@/views/monthReprt/tiktokFull/tiktokFull.vue') }
                },
                {
                    path: "tiktokThird",
                    name: "tiktokThird",
                    components: { table: () => import('@/views/monthReprt/tiktokThirdPatry/tiktokThirdPatry.vue') }
                },
                {
                    path: "sheinThird",
                    name: "sheinThird",
                    components: { table: () => import('@/views/monthReprt/sheinThirdPatry/sheinThirdPatry.vue') }
                },
                {
                    path: "walmartMonthReport",
                    name: "walmartMonthReport",
                    components: { table: () => import('@/views/monthReprt/walmart/walmartMonthReport.vue') }
                },
                {
                    path: "walmartAdvertisingBill",
                    name: "walmartAdvertisingBill",
                    components: { table: () => import('@/views/monthReprt/walmart/walmartAdvertisingBill.vue') }
                },
                {
                    path: "walmartDropShipping",
                    name: "walmartDropShipping",
                    components: { table: () => import('@/views/monthReprt/walmart/walmartDropShipping.vue') }
                },
                {
                    path: "wmsDeliveryOrder",
                    name: "wmsDeliveryOrder",
                    components: { table: () => import('@/views/wms/wmsDeliveryOrder.vue') }
                },
                {
                    path: "wmsWarehouseReceipt",
                    name: "wmsWarehouseReceipt",
                    components: { table: () => import('@/views/wms/wmsWarehouseReceipt.vue') }
                },
                {
                    path: "logisticsCostEstimate",
                    name: "logisticsCostEstimate",
                    components: { table: () => import('@/views/logistics/logisticsCostEstimate/index.vue') }
                },
                {
                    path: "skuWarehouseAge",
                    alias: "sku-warehouse-age",
                    name: "skuWarehouseAge",
                    components: { table: () => import('@/views/supply/warehouseAge/index.vue') }
                },
                {
                    path: "logisticsProviderQuote",
                    name: "logisticsProviderQuote",
                    components: { table: () => import('@/views/logistics/logisticsProviderQuote/index.vue') }
                },
                {
                    path: "listingdashboard",
                    name: "listingdashboard",
                    components: { table: () => import('@/views/listing/dashboard/index.vue') }
                },
                {
                    path: "logisticsRecommend",
                    name: "logisticsRecommend",
                    components: { table: () => import('@/views/logistics/logisticsRecommend') }
                }
            ],
        },
        // // 都是不需要如component
        // {
        //     path: '/abnormalLogistics',
        //     name: 'abnormalLogistics',
        //     component: () => import('@/views/abnormalLogistics/index'),
        // },
        // {
        //     path: '/unsalablePrice',
        //     name: 'unsalablePrice',
        //     component: () => import('@/views/unsalablePrice/index'),
        // },
        // {
        //     path: '/respSales',
        //     name: 'respSales',
        //     component: () => import('@/views/respSales/inde'),
        // },
        // {
        //     path: '/warehouse',
        //     name: 'warehouse',
        //     component: () => import('@/views/warehouse/index'),
        // },
        { path: '*', component: NotFound },
    ]
});

const createRouter = () =>
    new Router({
        mode: 'history', // require service support
        base: '/',
        scrollBehavior: () => ({ y: 0 }),
    });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

// 针对ElementUI导航栏中重复导航报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

